import React from "react";
import styled from "styled-components";
// import Keynotes from "./keynotes";

const InfoList = styled.ul`
  font-size: 1.3rem;
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    margin-bottom: 1rem;
  }
`;

const Information = () => (
  <>
    <InfoList data-testid="infolist">
      {/* <li>
        <h2>Keynotes:</h2>
        <Keynotes />
      </li> */}
      <li>
        <h2>
          <span role="img" aria-label="kalender">
            🗓
          </span>{" "}
          Dato
        </h2>
        PLASK blir 11. mars 2027.<br/>
      </li>
      <br />
      <li>
        <h2>
          <span role="img" aria-label="tidtaker">
            ⏲
          </span>{" "}
          Program
        </h2>
        <p>
          🗣️ Det blir talks 11.30-16
        </p>
        <p>
          🌊 Mageplask* starter 16:00 
        </p>
        <p>*MagePlask er det sosiale eventet som skjer etter PLASK. Her inviterer vi til mat og drikke, samt gode diskusjoner av dagens læring.</p>
      </li> 
      <br />
      <li>
        <h2>
          <span role="img" aria-label="telefon">
            📞
          </span>{" "}
          Slack
        </h2>
        Ta kontakt på Slack i kanalen #plask om du har spørsmål.
      </li>
      <br />
      <li>
        <h2>
          <span role="img" aria-label="telefon">
          👋
          </span>{" "}
          Påmelding til konferansen
        </h2>
        <p>Meld deg på årets Plask her: Link kommer</p>
      </li>
      <br />
      <li>
        <h2>
          <span role="img" aria-label="kamera">
            📷
          </span>{" "}
          Bilder
        </h2>
        Se bildene fra forrige Plask-konferanse og følg oss på Instagram <a href="https://www.instagram.com/plask_konferanse/">@plask_konferanse</a>
      </li>
      <br />
    </InfoList>
  </>
);

export default Information;
